import React from "react";
import MdaeSelectBox from "../select-box";
import MdaePopup, {
  MdaePopupTitle,
  MdaePopupContent,
  MdaePopupFooter,
  MdaePopupFooterEndButtons,
} from "../popup";
import MdaeButton from "../button";
import "./index.scss";
import {
  formatSystemMessagePopupFormDataToInsert,
  RESET_ADD_MESSAGES_POPUP_VALIDATION,
  SELECT_ALL_CLIENTS,
  SET_ADD_SYSTEM_MESSAGE_POPUP_DATA,
  TOGGLE_ADD_SYSTEM_MESSAGE_POPUP,
  TOGGLE_SYSTEM_NOTICE_POPUP,
} from "./reducers/notification-and-system-messages-reducer";
import { useDispatch, useSelector } from "react-redux";
import { Validator } from "devextreme-react";
import {
  CustomRule,
  RequiredRule,
  StringLengthRule,
} from "devextreme-react/validator";
import { actions as asyncActions } from "async-ops";
import MdaeDateBox from "../date-box";
import MdaeTextArea from "../text-area";
import { isEqual } from "lodash";
import { bindActionCreators } from "redux";
import { UPDATE_SYSTEM_MESSAGE } from "./services/update-system-message";
import { ADD_SYSTEM_MESSAGE } from "./services/add-system-message";
import { categories } from "./constants";
import MdaeCheckBox from "../check-box";
import MdaeList from "../list";
import { GET_SYSTEM_MESSAGES } from "./services/get-system-messages";
import mdaeNotfy, { NOTIFY_MESSAGE_TYPE } from "../toast/notify";
import { NotifyPopupConfigParams } from "../notify-popup";
import { popupMessageLeadTimeMinutes } from "../../../app/ApplicationEventHandler";
export const SYSTEM_MESSAGES_POPUP_MODES = {
  ADD: "ADD",
  EDIT: "EDIT",
  VIEW: "VIEW",
};
interface IAddSystemMessagePopup {
  toggleAddSystemMessagesPopupVisible: (
    dispatch,
    isVisible,
    title?,
    mode?,
    data?
  ) => void;
}
export const resetMessagesPopupFormData = (dispatch) => {
  dispatch({
    type: RESET_ADD_MESSAGES_POPUP_VALIDATION,
    data: {
      isMessagesPopupFormDataValid: true,
    },
  });
};
export const toggeleSystemNoticePopup = (dispatch, isVisible, messageData) => {
  dispatch({
    type: TOGGLE_SYSTEM_NOTICE_POPUP,
    data: {
      visible: isVisible,
      title: messageData.category,
      isHideNotifyTypeIcon: true,
      closeButtonText: "OK",
      width: 400,
      height: 250,
      removePopupContentStyles: true,
      contentHtml: () => (
        <div
          dangerouslySetInnerHTML={{
            __html: messageData.popupText.replace(/(\r\n|\n|\r)/g, "<br />"),
          }}
        ></div>
      ),
      isSmallPopup: true,
    } as NotifyPopupConfigParams,
  });
};

const AddSystemMessagePopup: React.FC<IAddSystemMessagePopup> = (props) => {
  const dispatch = useDispatch();
  const asyncAction = bindActionCreators(
    {
      asyncOperationStart: asyncActions.asyncOperationStart,
    },
    dispatch
  );
  const systemMessagePopupFormData = useSelector(
    (state: any) =>
      state.notificationAndSystemMessagesReducer.systemMessagePopupFormData,
    isEqual
  );
  const addAddSystemMessagesPopupMode = useSelector(
    (state: any) =>
      state.notificationAndSystemMessagesReducer.addAddSystemMessagesPopupMode,
    isEqual
  );
  const allClientIds = useSelector(
    (state: any) =>
      state.notificationAndSystemMessagesReducer.clientList.map(
        (x) => x?.clientId
      ),
    isEqual
  );

  const getSystemMessagePopupTitle = () => {
    return (
      <MdaePopupTitle
        closePopupHandler={() => {
          props.toggleAddSystemMessagesPopupVisible(dispatch, false);
        }}
      ></MdaePopupTitle>
    );
  };

  return (
      <MdaePopup
        deferRendering={false}
        height={600}
        width={1000}
        mdaeTitleRender={getSystemMessagePopupTitle}
        className="add-system-message-popup"
        mdaeDataUpdaterConfig={[
          {
            actionType: TOGGLE_ADD_SYSTEM_MESSAGE_POPUP,
            reducerName: "notificationAndSystemMessagesReducer",
            widgetOptionBindings: {
              visible: "isAddAddSystemMessagesPopupVisible",
              mdaePopupTitle: "addAddSystemMessagesPopupTitle",
            },
          },
        ]}
        mdaeContentRender={() => {
          return (
            <div>
              <MdaePopupContent>
                <div>
                  <div className={"widget-separation-margin-top"}>
                    <div className="vertical-split">
                      <div
                        className="vertical-split-left no-flex"
                        style={{ width: 720 }}
                      >
                        <div>
                          <MdaeSelectBox
                            required
                            id="pnlCategory"
                            mdaeDropDownBoxTitle="Category"
                            disabled={
                              addAddSystemMessagesPopupMode ===
                              SYSTEM_MESSAGES_POPUP_MODES.VIEW
                            }
                            dataSource={categories}
                            defaultValue={categories[0]}
                            mdaeDataUpdaterConfig={[
                              {
                                actionType: SET_ADD_SYSTEM_MESSAGE_POPUP_DATA,
                                reducerName:
                                  "notificationAndSystemMessagesReducer",
                                widgetOptionBindings: {
                                  value: "systemMessagePopupFormData.category",
                                },
                              },
                              {
                                actionType: RESET_ADD_MESSAGES_POPUP_VALIDATION,
                                reducerName:
                                  "notificationAndSystemMessagesReducer",
                                widgetOptionBindings: {
                                  isValid: "isMessagesPopupFormDataValid",
                                },
                              },
                            ]}
                          >
                            <Validator validationGroup="systemMessagesValidationGroup">
                              <RequiredRule message="Category is required" />
                            </Validator>
                          </MdaeSelectBox>
                        </div>
                        <div className={"widget-separation-margin-top"}>
                          <div className="vertical-split">
                            <div className="vertical-split-left">
                              <MdaeDateBox
                                required
                                id="dtPublishDate"
                                mdaeDateBoxTitle="Start Date"
                                disabled={
                                  addAddSystemMessagesPopupMode ===
                                  SYSTEM_MESSAGES_POPUP_MODES.VIEW
                                }
                                type="datetime"
                                mdaeDataUpdaterConfig={[
                                  {
                                    actionType: SET_ADD_SYSTEM_MESSAGE_POPUP_DATA,
                                    reducerName:
                                      "notificationAndSystemMessagesReducer",
                                    widgetOptionBindings: {
                                      value:
                                        "systemMessagePopupFormData.publishDate",
                                    },
                                  },
                                  {
                                    actionType: RESET_ADD_MESSAGES_POPUP_VALIDATION,
                                    reducerName:
                                      "notificationAndSystemMessagesReducer",
                                    widgetOptionBindings: {
                                      isValid: "isMessagesPopupFormDataValid",
                                    },
                                  },
                                ]}
                              >
                                <Validator validationGroup="systemMessagesValidationGroup">
                                  <RequiredRule message="Start Date is required" />
                                </Validator>
                              </MdaeDateBox>
                            </div>
                            <div className="vertical-split-right">
                              <MdaeDateBox
                                id="stEndDate"
                                required
                                mdaeDateBoxTitle="End Date"
                                disabled={
                                  addAddSystemMessagesPopupMode ===
                                  SYSTEM_MESSAGES_POPUP_MODES.VIEW
                                }
                                type="datetime"
                                mdaeDataUpdaterConfig={[
                                  {
                                    actionType: SET_ADD_SYSTEM_MESSAGE_POPUP_DATA,
                                    reducerName:
                                      "notificationAndSystemMessagesReducer",
                                    widgetOptionBindings: {
                                      value:
                                        "systemMessagePopupFormData.unpublishDate",
                                    },
                                  },
                                  {
                                    actionType: RESET_ADD_MESSAGES_POPUP_VALIDATION,
                                    reducerName:
                                      "notificationAndSystemMessagesReducer",
                                    widgetOptionBindings: {
                                      isValid: "isMessagesPopupFormDataValid",
                                    },
                                  },
                                ]}
                              >
                                <Validator validationGroup="systemMessagesValidationGroup">
                                  <RequiredRule message="End Date is required" />
                                </Validator>
                              </MdaeDateBox>
                            </div>
                          </div>
                        </div>
                        <div className={"widget-separation-margin-top"}>
                          <MdaeCheckBox
                            defaultValue={true}
                            id="chkshowAsPopup"
                            text={
                              "Show as popup " +
                              popupMessageLeadTimeMinutes +
                              " minutes before start date"
                            }
                            disabled={
                              addAddSystemMessagesPopupMode ===
                              SYSTEM_MESSAGES_POPUP_MODES.VIEW
                            }
                            mdaeDataUpdaterConfig={[
                              {
                                actionType: SET_ADD_SYSTEM_MESSAGE_POPUP_DATA,
                                reducerName:
                                  "notificationAndSystemMessagesReducer",
                                widgetOptionBindings: {
                                  value: "systemMessagePopupFormData.showAsPopup",
                                },
                              },
                            ]}
                          />
                        </div>
                        <div className={"widget-separation-margin-top"}>
                          <MdaeTextArea
                            id="txtSystemMessagePopupText"
                            required
                            placeholder="HTML tags can be used. Line breaks are auto-converted to <br/>"
                            mdaeTextAreaTitle="Popup Text"
                            disabled={
                              addAddSystemMessagesPopupMode ===
                              SYSTEM_MESSAGES_POPUP_MODES.VIEW
                            }
                            showRemainingCharecters
                            valueChangeEvent="keyup"
                            height={60}
                            maxLength={200}
                            mdaeDataUpdaterConfig={[
                              {
                                actionType: SET_ADD_SYSTEM_MESSAGE_POPUP_DATA,
                                reducerName:
                                  "notificationAndSystemMessagesReducer",
                                widgetOptionBindings: {
                                  value: "systemMessagePopupFormData.popupText",
                                },
                              },
                              {
                                actionType: RESET_ADD_MESSAGES_POPUP_VALIDATION,
                                reducerName:
                                  "notificationAndSystemMessagesReducer",
                                widgetOptionBindings: {
                                  isValid: "isMessagesPopupFormDataValid",
                                },
                              },
                            ]}
                          >
                            <Validator validationGroup="systemMessagesValidationGroup">
                              <RequiredRule message="Popup text is required" />
                              <StringLengthRule
                                min={1}
                                max={200}
                                message="Popup text length should be in a range from 1 to 200 characters."
                              />
                            </Validator>
                          </MdaeTextArea>
                        </div>
                        <div className={"widget-separation-margin-top"}>
                          <div className="vertical-split">
                            <div className="vertical-split-item">
                              <MdaeTextArea
                                id="txtSystemMessagePopuplongText"
                                placeholder="HTML tags can be used. Line breaks are auto-converted to <br/>"
                                mdaeTextAreaTitle="Login Text"
                                disabled={
                                  addAddSystemMessagesPopupMode ===
                                  SYSTEM_MESSAGES_POPUP_MODES.VIEW
                                }
                                showRemainingCharecters
                                valueChangeEvent="keyup"
                                onValueChanged={(e) => {
                                  if (e.event) {
                                    if (
                                      systemMessagePopupFormData.clientIds
                                        ?.length !== allClientIds?.length
                                    )
                                      dispatch({
                                        type: SELECT_ALL_CLIENTS,
                                        data: allClientIds,
                                      });
                                  }
                                }}
                                height={100}
                                maxLength={500}
                                mdaeDataUpdaterConfig={[
                                  {
                                    actionType: SET_ADD_SYSTEM_MESSAGE_POPUP_DATA,
                                    reducerName:
                                      "notificationAndSystemMessagesReducer",
                                    widgetOptionBindings: {
                                      value:
                                        "systemMessagePopupFormData.longText",
                                    },
                                  },
                                ]}
                              >
                                <Validator validationGroup="systemMessagesValidationGroup">
                                  <CustomRule
                                    validationCallback={(options) => {
                                      if (options.value && options.value.length) {
                                        return options.value.length > 20;
                                      } else {
                                        return true;
                                      }
                                    }}
                                    message="Long text is required to be more than 20 characters."
                                  />
                                </Validator>
                              </MdaeTextArea>
                            </div>
                            {systemMessagePopupFormData.longText?.length > 0 && (
                              <div className="field-info-box ">
                                <i
                                  className="fa fa-bell"
                                  title="Individual customers cannot be selected when a login message is displayed"
                                ></i>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className={"widget-separation-margin-top"}>
                          <MdaeTextArea
                            id="txtSystemMessageEmailText"
                            showRemainingCharecters
                            valueChangeEvent="keyup"
                            placeholder="HTML tags can be used. Line breaks are auto-converted to <br/>"
                            mdaeTextAreaTitle="Inbox Text"
                            disabled={
                              addAddSystemMessagesPopupMode ===
                              SYSTEM_MESSAGES_POPUP_MODES.VIEW
                            }
                            height={100}
                            maxLength={1000}
                            mdaeDataUpdaterConfig={[
                              {
                                actionType: SET_ADD_SYSTEM_MESSAGE_POPUP_DATA,
                                reducerName:
                                  "notificationAndSystemMessagesReducer",
                                widgetOptionBindings: {
                                  value: "systemMessagePopupFormData.emailText",
                                },
                              },
                            ]}
                          />
                        </div>
                      </div>
                      <div className="vertical-split-right">
                        <MdaeList
                          id="pnlSystemMessagesClientList"
                          keyExpr="clientId"
                          pageLoadMode="scrollBottom"
                          displayExpr="name"
                          disabled={
                            Boolean(systemMessagePopupFormData?.longText) ||
                            addAddSystemMessagesPopupMode ===
                              SYSTEM_MESSAGES_POPUP_MODES.VIEW
                          }
                          selectAllMode="allPages"
                          selectionMode="all"
                          showSelectionControls
                          searchEnabled
                          searchExpr="name"
                          mdaeListTitle="Applies To"
                          mdaeDataUpdaterConfig={[
                            {
                              actionType: GET_SYSTEM_MESSAGES,
                              isAsyncComplete: true,
                              widgetOptionBindings: {
                                dataSource: "clientList",
                              },
                            },
                            {
                              actionType: SET_ADD_SYSTEM_MESSAGE_POPUP_DATA,
                              reducerName: "notificationAndSystemMessagesReducer",
                              widgetOptionBindings: {
                                selectedItemKeys:
                                  "systemMessagePopupFormData.clientIds",
                              },
                            },
                            {
                              actionType: SELECT_ALL_CLIENTS,
                              reducerName: "notificationAndSystemMessagesReducer",
                              widgetOptionBindings: {
                                selectedItemKeys:
                                  "systemMessagePopupFormData.clientIds",
                              },
                            },
                          ]}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </MdaePopupContent>
            </div>
          );
        }}
        mdaeFooterRender={() => {
          return (
            <MdaePopupFooter>
              <MdaePopupFooterEndButtons>
                {addAddSystemMessagesPopupMode ===
                  SYSTEM_MESSAGES_POPUP_MODES.VIEW || (
                  <MdaeButton
                    id={"pnlCommentCategoryPrimarySaveBtn"}
                    role={"primary"}
                    validationGroup="systemMessagesValidationGroup"
                    onClick={(params) => {
                      let result = null;
                      if (params.validationGroup)
                        result = params.validationGroup.validate();
                      if (systemMessagePopupFormData.clientIds.length === 0) {
                        mdaeNotfy({
                          message: "Please select at lest one client.",
                          messageType: NOTIFY_MESSAGE_TYPE.ERROR,
                        });
                        return;
                      }
                      if (result && result.isValid) {
                        if (
                          addAddSystemMessagesPopupMode ===
                          SYSTEM_MESSAGES_POPUP_MODES.EDIT
                        ) {
                          asyncAction.asyncOperationStart(
                            UPDATE_SYSTEM_MESSAGE,
                            formatSystemMessagePopupFormDataToInsert(
                              systemMessagePopupFormData
                            )
                          );
                        } else {
                          asyncAction.asyncOperationStart(
                            ADD_SYSTEM_MESSAGE,
                            formatSystemMessagePopupFormDataToInsert(
                              systemMessagePopupFormData
                            )
                          );
                        }
                        props.toggleAddSystemMessagesPopupVisible(
                          dispatch,
                          false
                        );
                      }
                    }}
                  >
                    Save
                  </MdaeButton>
                )}
                <MdaeButton
                  id={"pnlCommentCategoryPrimarySaveAndCloseBtn"}
                  role={"primary"}
                  validationGroup="systemMessagesValidationGroup"
                  onClick={() => {
                    toggeleSystemNoticePopup(
                      dispatch,
                      true,
                      systemMessagePopupFormData
                    );
                  }}
                >
                  Preview Popup
                </MdaeButton>
              </MdaePopupFooterEndButtons>
            </MdaePopupFooter>
          );
        }}
      ></MdaePopup>
   );
};

export default AddSystemMessagePopup;
